import { useState, useEffect } from 'react';

// ── Helpers ───────────────────────────────────────────────────────────────────

export function getGroupOrder(projectNumber) {
  if (!projectNumber) return 3;
  if (/^JSID_/i.test(projectNumber)) return 1;
  if (/^JS_/i.test(projectNumber)) return 0;
  return 2;
}

export function sortProjects(rows) {
  return [...(rows || [])].sort((a, b) => {
    const ga = getGroupOrder(a.project_number);
    const gb = getGroupOrder(b.project_number);
    if (ga !== gb) return ga - gb;
    const cmp = (a.project_number || '').localeCompare(
      b.project_number || '',
      'th',
      { numeric: true },
    );
    // JS_ (group 0) → descending (newest first); JSID_ + others → ascending
    return ga === 0 ? -cmp : cmp;
  });
}

export const fmt = (n) => {
  const num = n == null ? 0 : Number(n);
  if (num === 0) return '-';
  return num.toLocaleString('th-TH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const fmtPct = (n) => (n == null ? '0.00%' : `${Number(n).toFixed(2)}%`);

export const fmtDate = (d) => {
  if (!d) return null;
  try {
    return new Date(d).toLocaleDateString('th-TH', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    });
  } catch {
    return null;
  }
};

export const toDateInput = (d) => {
  if (!d) return '';
  try {
    return new Date(d).toISOString().split('T')[0];
  } catch {
    return '';
  }
};

// ── Perceived perf: debounce helper (React 17 compat) ────────────────────────
export function useDebouncedValue(value, delay = 180) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
